import { render, staticRenderFns } from "./match2022m.vue?vue&type=template&id=26b581ca"
import script from "./match2022m.vue?vue&type=script&lang=js"
export * from "./match2022m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports